var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .st0, .st1 {\n        stroke: #f2f6ff;\n      }\n\n      .st1 {\n        fill: #1d2026;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.26,100.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.26,318.62"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 89.95,
    r: 47.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.56,89.95H66.23M303.44,89.95h142.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.61,469.5h-237.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,137.39v332.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.22,303.44c0,39.3-31.86,71.17-71.17,71.17s-71.17-31.86-71.17-71.17M493.22,303.44l-59.3-142.33h-23.72l-59.3,142.33M493.22,303.44h-142.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.11,303.44c0,39.3-31.86,71.17-71.17,71.17s-71.17-31.86-71.17-71.17M161.11,303.44l-59.3-142.33h-23.72l-59.3,142.33M161.11,303.44H18.78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.fc4ef9630df24aedb66374cdfc0ab65e.svg";
export { ForwardRef as ReactComponent };